module.exports = __webpack_public_path__ + "images/feature/calendar-1-14243b81e244af037eff0c82b5f11bb0.jpg";